import { GetCurrentUserResult } from "app/users/queries/getCurrentUser"
import type { Organization, Subscription } from "db/client"

export type MinimalOrganizationWithSubscription = Pick<
  Organization,
  "overrideGroupCountLimit"
> & {
  subscription: Pick<
    Subscription,
    "hasAccessToKidsPage" | "defaultGroupCountLimit"
  >
}

export function doesOrganizationHaveGroupAccess(
  currentOrganization: MinimalOrganizationWithSubscription | null,

  currentUser:
    | Pick<NonNullable<GetCurrentUserResult>, "role">
    | null
    | undefined
) {
  if (!currentUser) {
    return false
  }

  if (currentUser.role === "ADMIN") {
    return true
  }

  if (currentOrganization === null) {
    return false
  }

  if (
    typeof currentOrganization.overrideGroupCountLimit === "number" &&
    currentOrganization.overrideGroupCountLimit === 0
  ) {
    return false
  } else if (
    typeof currentOrganization.overrideGroupCountLimit === "number" &&
    currentOrganization.overrideGroupCountLimit > 0
  ) {
    return true
  }

  if (currentOrganization.subscription.defaultGroupCountLimit === 0) {
    return false
  } else if (currentOrganization.subscription.defaultGroupCountLimit > 0) {
    return true
  }

  // Typically no access to kids page also means no group, the exceptions are handled above
  if (!currentOrganization.subscription.hasAccessToKidsPage) {
    return false
  }

  return true
}
